var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":`/qrscan`}},[_c('button',{staticClass:"glossy-button glossy-button--grey"},[_c('i',{staticClass:"fa fa-camera"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }